// The addresses of the groups of «Настройки» in Latin (quality review 30.10, review 31.10 B4): a group names its address in the
// declaration (`slug`), so it never moves when another group appears or goes; a group without one takes the common start of its keys.

/** Items of «Настройки» that are not groups: a group never takes their address. */
export const ITEM_KEYS = ['profile', 'account', 'team', 'schema'];

/** Addresses that used to point at groups, before every group had its own (B4, B6): /settings/account-2 was the time zone. */
export const OLD_SLUGS: Record<string, string> = { 'account-2': 'general', 'account-3': 'support' };

/** The slug of each group, in their order; a group whose start another group took gets its own number after it. */
export function groupSlugs(groups: string[], decls: { key: string; group: string; slug?: string }[], extra: Record<string, string> = {}): Map<string, string> {
  const out = new Map<string, string>();
  const used = new Set<string>(ITEM_KEYS);
  const named = (g: string) => extra[g] ?? decls.find((d) => d.group === g && d.slug)?.slug;
  // Declared addresses first: an undeclared group never pushes a declared one to a number.
  for (const g of groups) { const n = named(g); if (n && !used.has(n)) { used.add(n); out.set(g, n); } }
  for (const g of groups) {
    if (out.has(g)) continue;
    const first = decls.find((d) => d.group === g)?.key.split('.')[0]?.toLowerCase().replace(/[^a-z0-9-]/g, '') || 'group';
    let slug = first;
    for (let i = 2; used.has(slug); i++) slug = `${first}-${i}`;
    used.add(slug);
    out.set(g, slug);
  }
  return new Map(groups.map((g) => [g, out.get(g)!]));
}
